<nav class="w-full bg-coka-blue border-gray-700">
  <div class="w-full flex justify-between flex-wrap items-center mx-auto p-4">

    <!-- Logo a sinistra -->
    <a href="#" class="flex items-center space-x-3 rtl:space-x-reverse ml-2">
      <img src="https://www.cokaclubbologna.it/wp-content/uploads/2020/02/logo-coka.png" class="h-8"
        alt="CokaClub Logo" />
    </a>


    <!-- Tabs al centro -->
    <div *ngIf="!isNoCalendarRoute()" class="text-sm font-medium text-center border-b text-gray-400 border-gray-700">
      <ul class="flex flex-wrap -mb-px">
        <li class="me-2">
          <a *ngIf="day !== today; else notToday" [routerLink]="[activeRoute != '' ? activeRoute : 'calendario', today]"
            class="today-tab">
            Torna ad Oggi
          </a>
          <ng-template #notToday>
            <a [routerLink]="[activeRoute != '' ? activeRoute : 'calendario', yestarDay]" class="tab ">
              Ieri
            </a>
          </ng-template>
        </li>
        <li *ngFor="let day of weekDays; let isFirst = first" class="me-2">
          <!-- Se è il primo giorno della settimana, aggiungo il link attivo -->
          <a *ngIf="isFirst; else notFirst"
            [routerLink]="[activeRoute != '' ? activeRoute : 'calendario', day.dayString]" class="active-tab">
            {{ day.name }} {{ day.day }}
          </a>
          <ng-template #notFirst>
            <a [routerLink]="[activeRoute != '' ? activeRoute : 'calendario', day.dayString]" class="tab">
              {{ day.name }} {{ day.day }}
            </a>
          </ng-template>
        </li>
        <li class="me-2">
          <div class="inline-block p-4  rounded-t-lg text-coka-pink" style="width: 50px; height: 35px">
            <div class="relative w-full h-full">
              <input matInput [matDatepicker]="picker" [(ngModel)]="day" (dateChange)="onDateChange($event)"
                class="opacity-0 absolute inset-0">
              <button (click)="picker.open()" class="text-xl absolute inset-0 h-full">
                <fa-icon [icon]="faCalendarDays"></fa-icon>
              </button>
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>
        </li>
      </ul>
    </div>


    <!-- Menu a  destra -->
    <div class="hidden w-full md:block md:w-auto mr-2" id="navbar-solid-bg">
      <ul
        class="flex flex-col font-medium mt-4 rounded-lg  md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 bg-gray-800 md:bg-transparent border-gray-700">
        <li>
          <a routerLink="/calendario/{{ day }}" routerLinkActive="active-menu" class="menu">
            Calendario
          </a>
        </li>
        <li>
          <a routerLink="/note/{{ day }}" routerLinkActive="active-menu" class="menu">
            Note
          </a>
        </li>
        <li>
          <button id="dropdownNavbarLink" data-dropdown-toggle="dropdownNavbar" class="menu">
            Avanzate
          </button>
          <!-- Dropdown menu -->
          <div id="dropdownNavbar"
            class="z-10 hidden font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600">
            <ul class="py-2 text-sm text-gray-700 dark:text-gray-400" aria-labelledby="dropdownLargeButton">
              <li>
                <a routerLink="/admin/{{ day }}" class="dropdown-menu">
                  Admin
                </a>
              </li>
              <li>
                <a (click)="blockPeriodo()" class="dropdown-menu">
                  Chiudi negozio
                </a>
              </li>
              <li *ngIf="hasStampa">
                <a (click)="stampa()" class="dropdown-menu">
                  Stampa
                </a>
              </li>
              <li *ngIf="hasBlockList">
                <a routerLink="/block-list" class="dropdown-menu">
                  Blocca numeri
                </a>
              </li>
              <li>
                <a routerLink="/change-password" class="dropdown-menu">
                  Modifica password
                </a>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <a (click)="onLogout()" class="logout cursor-pointer">
            Logout <fa-icon [icon]="faPowerOff"></fa-icon>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
